// extracted by mini-css-extract-plugin
export default {"container":"TicketsPage_container__k+bQ-","containerOne":"TicketsPage_containerOne__3OpOI","header":"TicketsPage_header__4HJd3","cards":"TicketsPage_cards__-I46P"};